import { ReactNode, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const stored = localStorage.getItem("hr-flash-sidebar-collapsed");
    return stored === "true";
  });

  // Hide main sidebar on settings page - settings has its own navigation
  const isSettingsPage = location.pathname === "/settings";

  useEffect(() => {
    const handleStorageChange = () => {
      const stored = localStorage.getItem("hr-flash-sidebar-collapsed");
      setIsCollapsed(stored === "true");
    };

    // Listen for localStorage changes
    window.addEventListener("storage", handleStorageChange);
    
    // Also poll for changes since storage event doesn't fire in same tab
    const interval = setInterval(() => {
      const stored = localStorage.getItem("hr-flash-sidebar-collapsed");
      setIsCollapsed(stored === "true");
    }, 100);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      {/* Only show main sidebar when NOT on settings page */}
      {!isSettingsPage && <Sidebar />}
      <main
        className={cn(
          "transition-all duration-300",
          // No margin when on settings page (settings has its own sidebar)
          isSettingsPage ? "ml-0" : (isMobile ? "ml-0" : (isCollapsed ? "ml-16" : "ml-64"))
        )}
      >
        {children}
      </main>
    </div>
  );
};

export default Layout;
